import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './Collapsible.scss';

export default function Collapsible({
	title,
	summary = '',
	children,
	defaultOpened = false,
	className = ''
}) {
	const [open, setOpen] = useState(null);
	const contentsClasses = ['Collapsible-content', 'ml-4', 'b-block'];
	const style = {};
	const isOpen = open === null ? defaultOpened : open;
	if (isOpen) {
		style.transform = 'rotate(90deg)';
	}
	return (
		<div className={className}>
			<button
				type="button"
				className={[
					'Collapsible-title',
					'w-100',
					'btn-unstyled',
					'd-block',
					'text-left',
					'border-0'
				].join(' ')}
				onClick={() => setOpen(!open)}
			>
				<i
					className={[
						'd-inline-block',
						'ddc-icon',
						'ddc-icon-chevron-right',
						'ddc-icon-size-large'
					].join(' ')}
					style={style}
				/>
				{title}: <small className="text-muted">{summary}</small>
			</button>
			{isOpen && (
				<div className={contentsClasses.join(' ')}>{children}</div>
			)}
		</div>
	);
}

Collapsible.propTypes = {
	title: PropTypes.string.isRequired,
	summary: PropTypes.string,
	children: PropTypes.arrayOf(PropTypes.element),
	defaultOpened: PropTypes.bool,
	className: PropTypes.string
};
